import Button from '@eversports/klimt-primitives/legacy/Button'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import SeoLink from '@eversports/klimt-primitives/legacy/SeoLink'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { DiscoverPrefix } from '../../../../App.types'
import { Localized } from '../../../../localization/react'

import type { CityData } from './NotFound.types'

interface Props {
  cityData: CityData
}

const OtherSports = ({ cityData }: Props) => (
  <Stack gap={3} width={{ md: '50vw' }}>
    <Heading is="h2" variant="small" color="midnight">
      <Localized id="discover-no-results-popular-sports-label" params={{ city: cityData.name }} />
    </Heading>
    <Stack direction="row" gap={3} flexWrap="wrap">
      {cityData.popularSports.map((sport) => {
        const to = new URL(
          `${DiscoverPrefix.APP_SPORT_CITY}/${sport.slug}/${cityData.slug}`,
          `https://${cityData.canonicalHost}`,
        ).toString()
        return (
          <SeoLink key={sport.id} type="hidden" encodedTo={btoa(to)} external>
            <Button
              variant="tertiary"
              sx={{ px: 3, py: 2, border: '1px solid', borderColor: 'lightgray', textTransform: 'none' }}
            >
              <Text>{sport.name}</Text>
            </Button>
          </SeoLink>
        )
      })}
    </Stack>
  </Stack>
)

export default OtherSports
